<template>
  <div>
    <App v-bind="attributes" />
  </div>
</template>

<script>
export default {};
</script>
